import { PropsWithChildren } from 'react';

export const FormActionsRow = ({ children }: PropsWithChildren) => (
  <div className="flex row justify-around gap-4">{children}</div>
);
